module.exports = __webpack_public_path__ + "themes/mf/img/button-hover.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/button-hover.png
// module id = 27
// module chunks = 3